import React, { useEffect, useState } from "react";
import { userProfile } from "../api/Api";
import { userId, userToken } from "../../Utils/userAuth";
import "./WtPrev5.css";
import {
  FiPackage,
  FiMessageSquare,
  FiHeadphones,
  FiZap,
  FiSend,
  FiShoppingCart,
} from "react-icons/fi";

const WtPrev5 = (props) => {
  const [inputVal, setInputVal] = useState("");
  const [parent_id, setParent_id] = useState(null);
  const [parentType, setParentType] = useState(null);
  const [brandName, setBrandName] = useState("");

  useEffect(() => {
    const siteSettings = localStorage.getItem("siteSettings");
    if (siteSettings) {
      const parsed = JSON.parse(siteSettings);
      setBrandName(parsed.brand_name || "");
    }
  }, []);

  useEffect(() => {
    const storedLogin = localStorage.getItem("login");
    if (storedLogin) {
      const parsed = JSON.parse(storedLogin);
      setParentType(parsed?.user?.parent_type || null);
    }

    const paramData = {
      user_id: userId,
      token: userToken,
      method: "retrieve",
    };

    userProfile(paramData).then((result) => {
      if (result.data.success === true) {
        setParent_id(result.data.data[0].parent);
      }
    });
  }, []);

  const toggleWidget = () => {
    const td = document.getElementById("authkey-tgl");
    if (!td) return;
    td.classList.toggle("authkey-ds");
    td.classList.toggle("authkey-dh");
  };

  const closeWidget = () => {
    const td = document.getElementById("authkey-tgl");
    if (!td) return;
    td.classList.remove("authkey-ds");
    td.classList.add("authkey-dh");
  };

  const sendMessage = () => {
    const encodedText = encodeURIComponent(inputVal);
    const url = `https://wa.me/${props.mobile_no}?text=${encodedText}`;
    window.open(url, "_blank");
  };

  return (
    <div style={{ position: "relative", height: "100%" }}>
      <div
        className="wt5-wrapper"
        style={{
          [props.position]: `${props.sidemargin}px`,
          bottom: `${props.marginbottom}px`,
        }}
      >
        {/* Widget Card */}
        <div
          id="authkey-tgl"
          className={`wt5-card ${
            props.wtstatus === "yes" ? "authkey-ds" : "authkey-dh"
          }`}
        >
          <div className="wt5-card-inner">
            {/* Header */}
            <div
              className="wt5-header"
              style={{
                background:
                  props.bgcolor || "linear-gradient(180deg,#0fa054,#0da34b)",
              }}
            >
              <div className="wt5-avatar-area">
                <div className="wt5-avatar">
                  <img
                    src={props.logourl}
                    alt="avatar"
                    className="wt5-avatar-img"
                  />
                  <span className="wt5-avatar-online" />
                </div>
              </div>

              <div className="wt5-title-area">
                <div className="wt5-title">
                  {props.displayname || "Shopping Assistant"}
                </div>
                <div className="wt5-subtitle">Order help & support</div>
              </div>

              <button className="wt5-close" onClick={closeWidget} aria-label="close">
                ×
              </button>
            </div>

            {/* Body */}
            <div className="wt5-body">
              <div className="wt5-info-card">
                <div className="wt5-info-top">
                  <div className="wt5-info-text">
                    {"👋 Need help with your order? Chat with us!"}
                  </div>
                </div>

                <ul className="wt5-features">
                  <li>
                    <span className="wt5-feature-icon">
                      <FiPackage />
                    </span>
                    <span>Track your order</span>
                  </li>
                  <li>
                    <span className="wt5-feature-icon">
                      <FiHeadphones />
                    </span>
                    <span>Product inquiries</span>
                  </li>
                  <li>
                    <span className="wt5-feature-icon">
                      <FiMessageSquare />
                    </span>
                    <span>After-sales support</span>
                  </li>
                </ul>
              </div>

              <div className="wt5-response">
                <div className="wt5-response-label">
                   ⚡ Average response time
                </div>
                <div className="wt5-response-time">&lt; 2 minutes</div>
              </div>

              <div className="wt5-input-row">
                <input
                  id="authkey-message-input3"
                  className="wt5-input"
                  placeholder="Type your message..."
                  value={inputVal}
                  onChange={(e) => setInputVal(e.target.value)}
                />
                <button
                  className="wt5-send"
                  onClick={sendMessage}
                  aria-label="send"
                >
                  <FiSend />
                </button>
              </div>

              {!props.removeBranding && (
              <div className="wt5-footer">
                <div className="wt5-footer-inner">
                  {parentType === "reseller" ? (
                    parent_id === 10774 ? (
                      <p className="wt5-brand">
                        by <span>adznetworkmedia.om</span>
                      </p>
                    ) : parent_id === 5643 ? (
                      <p className="wt5-brand">
                        by <span>cpaasnettyfish.com</span>
                      </p>
                    ) : brandName && brandName.trim() !== "" ? (
                      <p className="wt5-brand">
                        by <span>{brandName}</span>
                      </p>
                    ) : null
                  ) : (
                    <p className="wt5-brand">
                      <span className="wt5-text">Powered by </span>
                      <a
                        href="https://authkey.io"
                        target="_blank"
                        rel="noreferrer"
                        className="wt5-link"
                      >
                        Authkey.io
                      </a>
                    </p>
                  )}
                </div>
              </div>
              )}
            </div>
          </div>
        </div>

        {/* Floating Button */}
        <button
          className="wt5-float-btn"
          id="authkey-wt-btn"
          onClick={toggleWidget}
          aria-label="open chat"
        >
          <FiShoppingCart className="wt5-cart-icon" />
          <span className="wt5-badge"></span>
        </button>
      </div>
    </div>
  );
};

export default WtPrev5;
